<!-- <div class="title_bar--item title_bar--search" [ngClass]="{ 'focused': searchFocus }"> -->
<div *sm-has-permission="TENANT_PERMISSIONS.Base_Work_Accounts_SearchAccounts" class="title_bar--item title_bar--search" [ngClass]="{ 'focused': searchFocus }">
    <ng-container *sm-has-env-flag="'auroraV1'">
        <div class="search_wrap">
            <aurora-input-text-single
                class="input-search"
                type="search"
                prefix-icon="search"
                [value]="searchValue"
                [placeholder]="'Search ' + ('Accounts' | smNomenclatureByRegion:null | async) + '...'"
                (mouseover)="onSearchOver()"
                (mouseout)="onSearchOut()"
                (focus)="onSearchFocus()"
                (blur)="onSearchBlur()"
                (input-change)="onSearchInputChange($event)">
            </aurora-input-text-single>
            <div
                *ngIf="searchFocus"
                class="results"
                [class.has_results]="foundAccounts.length"
                (mousedown)="onResultsMouseDown()"
                (mouseover)="onSearchOver()"
                (mouseout)="onSearchOut()">
                <div class="message">
                    <svg *ngIf="searching" class="icon-completing">
                        <use xlink:href="#icon-completing"></use>
                    </svg> {{searchMessage}}
                </div>
                <div class="results--list">
                    <aurora-menu
                        #searchMenu
                        aurora-light
                        [items]="searchMenuItems"
                        [showFilter]="false"
                        [showEmptyState]="false"
                        (item-click)="onSearchMenuItemClick($event)">
                    </aurora-menu>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-container *sm-has-not-env-flag="'auroraV1'">
        <div class="search_wrap">
            <input class="form-control input-search"
                   type="search"
                   [placeholder]="'Search ' + ('Accounts' | smNomenclatureByRegion:null | async) + '...'"
                   #search
                   (mouseover)="onSearchOver()"
                   (mouseout)="onSearchOut()"
                   (focus)="onSearchFocus()"
                   (blur)="!overSearch && onSearchBlur()"
                   (keyup)="onSearchKeyup($event)"
                   [(ngModel)]="searchValue" />
            <button unity-button *ngIf="searchHasValue" class="icon-only" (click)="clearSearchInput()" (mouseover)="onSearchOver()">
                <svg class="unity-icon-times">
                    <use xlink:href="#unity-icon-times"></use>
                </svg>
            </button>
            <svg *ngIf="!searchHasValue" class="icon-search">
                <use xlink:href="#icon-search"></use>
            </svg>
            <div *ngIf="searchFocus" class="results" [class.has_results]="foundAccounts.length">
                <div class="message">
                    <svg *ngIf="searching" class="icon-completing">
                        <use xlink:href="#icon-completing"></use>
                    </svg> {{searchMessage}}
                </div>
                <div class="results--list">
                    <ng-container *ngFor="let foundAccount of foundAccounts; let i=index">
                        <sm-quick-search-card id="QuickSearchCard:{{ foundAccount.data.id }}"
                                              [MatchedItem]="foundAccount"
                                              [SearchType]="searchType"
                                              (mousedown)="onSearchAccountAdded(foundAccount.data)">
                        </sm-quick-search-card>
                        <ng-container *ngIf="foundAccounts.length - 1 != i">
                            <hr>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>
</div>
